// extracted by mini-css-extract-plugin
export default {"storyList":"c-a_cA"};